module.exports = __webpack_public_path__ + "static/media/Dashboard.841530aa.svg";